import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Link, LinkProps } from '@mui/material';

interface LinkRouterProps extends LinkProps {
  to: string;
  replace?: boolean;
}

export default function LinkRouter(props: LinkRouterProps) {
  return <Link {...props} component={RouterLink} />;
}

LinkRouter.defaultProps = {
  replace: false,
};
